import { MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE } from "@faire/retailer-visitor-shared/features/Marketplace/styleConsts";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
var MARKETPLACE_LEFT_AND_RIGHT_MARGIN_TABLET = 48;
export var OuterResultsContentWrapper = styled.div.withConfig({
    componentId: "sc-cc771301-0"
})([
    "min-height:100vh;width:100%;min-width:0;display:flex;flex-direction:column;flex-grow:1;flex-wrap:nowrap;padding:0 ",
    "px 16px;",
    "{padding:10px ",
    "px 0;}",
    "{padding-left:0;}"
], MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE, responsiveMediaQueries.tabletAndAbove, MARKETPLACE_LEFT_AND_RIGHT_MARGIN_TABLET, responsiveMediaQueries.desktopAndAbove);
